import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CtaBanner } from "./Home";
import { IMG, SERVICES } from "../data/site";

const Icon = ({ name, ...p }) => { const C = Icons[name] || Icons.Snowflake; return <C {...p} />; };

const Services = () => (
  <div data-testid="services-page">
    <PageHero eyebrow="OUR SERVICES" title="Complete heating & cooling solutions" subtitle="Residential and commercial HVAC, installed and maintained by licensed Melbourne specialists." image={IMG.ductwork} crumbs={[{ label: "Services" }]} />
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 space-y-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.04}>
            <Link to={`/services/${s.slug}`} data-testid={`services-row-${s.slug}`} className="group grid md:grid-cols-2 rounded-3xl overflow-hidden border border-black/5 bg-js-grey hover:shadow-[0_20px_50px_rgba(11,78,162,0.12)] transition-shadow duration-400">
              <div className={`relative h-64 md:h-auto min-h-[280px] ${i % 2 ? "md:order-2" : ""}`}>
                <img src={s.image} alt={s.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-js-blue text-white mb-5"><Icon name={s.icon} size={22} /></span>
                <h2 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight">{s.name}</h2>
                <p className="text-js-charcoal/60 mt-3 leading-relaxed">{s.overview}</p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {s.points.slice(0, 4).map((p) => <span key={p} className="px-3 py-1.5 rounded-full bg-white border border-black/5 text-xs font-medium text-js-charcoal/70">{p}</span>)}
                </div>
                <span className="flex items-center gap-2 text-js-blue font-semibold mt-6 group-hover:gap-3 transition-all duration-300">Learn more <ArrowRight size={18} /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
    <CtaBanner />
  </div>
);

export default Services;
